





















































































import { Component, Mixins, Prop } from 'vue-property-decorator';
import { Actions, Mutations } from '@/ts/store/Constants';
import InputFieldMethods from '@/mixins/InputFieldMethods.vue';
import LanguagesDropDown from '@/components/DropDowns/LanguagesDropDown.vue';

@Component({
    components: {
        LanguagesDropDown,
    },
})
export default class CorporationLinkForm extends Mixins(InputFieldMethods) {
    @Prop({default: 'add'}) public mode: string;
    
    public readonly FORM_EDIT_MODE = 'edit';
    public readonly FORM_ADD_MODE = 'add';
    
    public currentLanguage = 'en';
    public languages: any = [];
    public linkDescriptions: any = [];
    public linkTitles: any = [];
    public linkUrls: any = [];

    constructor() {
        super();
    }

    get errorCollection() {
        return this.errors.any();
    }

    get getCorporationLinkData(): any {
        return this.$store.getters['CorporationLinks/getCurrentCorporationLink'];
    }

    public cancel() {
        this.$store.commit(Mutations.SET_CORPORATION_LINK_FORM_VISIBILITY, false);
    }

    public beforeDestroy() {
        this.cancel();
    }

    public setTranslatableFields(languages: any) {
        languages.forEach((language: any) => {
            this.addTranslation(language);
        });
    }

    public addTranslation(addedLanguage: any) {
        let content: any;
        if (this.mode === this.FORM_EDIT_MODE) {
            const corporationLink = this.getCorporationLinkData;
            content = corporationLink.languageVersions.find((translation: any) => translation.language_id === addedLanguage.id);
        } 
        const checkIfExist = this.linkTitles.find((title: any) => title.lang === addedLanguage.key);

        if (typeof checkIfExist === 'undefined') {
            this.linkTitles.push({ lang: addedLanguage.key, content: typeof content === 'undefined' ? '' : content.title });
            this.linkDescriptions.push({ lang: addedLanguage.key, content: typeof content === 'undefined' ? '' : content.description });
            this.linkUrls.push({ lang: addedLanguage.key, content: typeof content === 'undefined' ? '' : content.url });
        }
    }

    public removeTranslation(deletedLanguage: any) {
        this.linkTitles       = this.linkTitles.filter((title: any) => title.lang !== deletedLanguage.key);
        this.linkDescriptions = this.linkDescriptions.filter((description: any) => description.lang !== deletedLanguage.key);
        this.linkUrls         = this.linkUrls.filter((url: any) => url.lang !== deletedLanguage.key);
    }

    public setCurrentLanguage(selectedLanguage: any) {
        this.currentLanguage = selectedLanguage.key;
    }

    public saveChanges() {
        const corporationLink = this.getCorporationLinkData;
        this.$validator.validate().then((valid) => {
            if (valid) {
                if (this.mode === this.FORM_EDIT_MODE) {
                    this.$store.dispatch(Actions.UPDATE_CORPORATION_LINK, {
                        id: corporationLink.id,
                        linkTitles: this.linkTitles,
                        linkDescriptions: this.linkDescriptions,
                        linkUrls: this.linkUrls,
                    });
                } else {
                    this.$store.dispatch(Actions.ADMIN_ADD_CORPORATION_LINK, {
                    linkTitles: this.linkTitles,
                    linkDescriptions: this.linkDescriptions,
                    linkUrls: this.linkUrls,
                });
                }
                this.cancel();
            }
        });
    }

    public created() {
        if (this.mode === this.FORM_EDIT_MODE && this.getCorporationLinkData && this.getCorporationLinkData.languageVersions) {
            this.languages = this.getCorporationLinkData.languageVersions.map((linkData: any) => linkData.language_id);
        }
    }
}
